import { Trans } from '@lingui/react';
import { i18n } from '@lingui/core';
import { useBreakpoint, callAllHandlers, Nav, ProductIcon } from '@landr/maestro';
import React from 'react';
import '../../../../../../../utils/analytics/index.es.js';
import { useLinkClickHandler } from '../../../../../hooks/useLinkClickHandler.es.js';
import { useLinkAnalyticsV2Handler } from '../../../../../hooks/useLinkAnalyticsV2Handler.es.js';
import { useIsCurrentLink } from '../../../../../hooks/useIsCurrentLink.es.js';
import { getPluginsLink, getWebAppLink, openLink } from '../../../../../../../utils/links.es.js';
import { NavBarItem } from './NavBarItem.es.js';
import { NavCollapse } from './MobileNavCollapse.es.js';
import { CtaGoal } from '../../../../../../../utils/analytics/PlatformAnalyticsV2Service.generated.es.js';
import { useNavBarContext } from '../../../../../../../contexts/NavBarProvider/NavBarContext.es.js';
import { getSamplesLink, getGuestSiteLink, getNetworkLink } from '@landr/core';
import { Links } from '../../../../../../../enums/Links.es.js';
import { NavItems } from '../../../../../../../enums/NavItems.es.js';

var NavBarItems = function NavBarItems(_ref) {
  var closeDrawer = _ref.closeDrawer;
  var _useNavBarContext = useNavBarContext(),
    env = _useNavBarContext.env,
    language = _useNavBarContext.language,
    user = _useNavBarContext.user;
  var sendAnalyticsV2Handler = useLinkAnalyticsV2Handler();
  var linkClickHandler = useLinkClickHandler();
  var isCurrentLink = useIsCurrentLink();
  var isTablet = useBreakpoint('lg');
  var closeDrawerHandler = isTablet ? closeDrawer : function () {
    return undefined;
  };
  var urls = {
    samples: getSamplesLink(env),
    creator: getSamplesLink(env, Links.Creator),
    plugins: user ? getPluginsLink(env, "".concat(Links.MyPlugins)) : getGuestSiteLink(env, "/".concat(language).concat(Links.Plugins)),
    messages: user ? getWebAppLink(env, Links.Messages) : getGuestSiteLink(env, Links.CollabGuestPage),
    networkUsers: getNetworkLink(env, Links.Users),
    networkPro: getNetworkLink(env, Links.Pros),
    networkServices: getNetworkLink(env, Links.BecomePro),
    communityChannels: getWebAppLink(env, Links.CommunityChannels)
  };
  var props = {
    samples: {
      onClick: callAllHandlers(closeDrawerHandler, sendAnalyticsV2Handler(CtaGoal.GotoSamples, 'Samples', urls.samples), linkClickHandler(openLink, urls.samples)),
      href: urls.samples,
      isCurrent: isCurrentLink(NavItems.Samples)
    },
    plugins: {
      onClick: callAllHandlers(closeDrawerHandler, sendAnalyticsV2Handler(CtaGoal.GotoPlugins, 'Plugins', urls.plugins), linkClickHandler(openLink, urls.plugins)),
      href: urls.plugins,
      isCurrent: isCurrentLink(NavItems.Plugins)
    },
    messages: {
      onClick: callAllHandlers(closeDrawerHandler, sendAnalyticsV2Handler(CtaGoal.GotoMessages, 'Share and chat', urls.messages), linkClickHandler(openLink, urls.messages)),
      href: urls.messages
    },
    networkUsers: {
      onClick: callAllHandlers(closeDrawerHandler, sendAnalyticsV2Handler(CtaGoal.GotoNetwork, 'Connect with creators', urls.networkUsers), linkClickHandler(openLink, urls.networkUsers)),
      href: urls.networkUsers
    },
    networkPro: {
      onClick: callAllHandlers(closeDrawerHandler, sendAnalyticsV2Handler(CtaGoal.GotoNetwork, 'Hire a pro', urls.networkPro), linkClickHandler(openLink, urls.networkPro)),
      href: urls.networkPro
    },
    networkServices: {
      onClick: callAllHandlers(closeDrawerHandler, sendAnalyticsV2Handler(CtaGoal.GotoNetwork, 'Sell services', urls.networkServices), linkClickHandler(openLink, urls.networkServices)),
      href: urls.networkServices
    },
    communityChannels: {
      onClick: callAllHandlers(closeDrawerHandler, sendAnalyticsV2Handler(CtaGoal.GotoCommunityChannels, 'Community channels', urls.communityChannels), linkClickHandler(openLink, urls.communityChannels)),
      href: urls.communityChannels
    }
  };
  if (isTablet) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, Object.assign({
      px: "xs"
    }, props.samples), /*#__PURE__*/React.createElement(Trans, {
      id: "d2mxgE"
    }))), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, Object.assign({
      px: "xs"
    }, props.plugins), /*#__PURE__*/React.createElement(Trans, {
      id: "ohUJJM"
    }))), /*#__PURE__*/React.createElement(NavCollapse.Head, {
      title: i18n._(
      /*i18n*/
      {
        id: "dtQIWT"
      })
    }, /*#__PURE__*/React.createElement(NavCollapse.Item, Object.assign({}, props.messages, {
      text: i18n._(
      /*i18n*/
      {
        id: "Zw99NK"
      })
    })), /*#__PURE__*/React.createElement(NavCollapse.Item, Object.assign({}, props.networkUsers, {
      text: i18n._(
      /*i18n*/
      {
        id: "Uy2lzu"
      })
    })), /*#__PURE__*/React.createElement(NavCollapse.Item, Object.assign({}, props.networkPro, {
      text: i18n._(
      /*i18n*/
      {
        id: "LBrqUz"
      })
    })), /*#__PURE__*/React.createElement(NavCollapse.Item, Object.assign({}, props.networkServices, {
      text: i18n._(
      /*i18n*/
      {
        id: "lqRo22"
      })
    })), /*#__PURE__*/React.createElement(NavCollapse.Item, Object.assign({}, props.communityChannels, {
      text: i18n._(
      /*i18n*/
      {
        id: "MPEFN9"
      }),
      badgeTitle: i18n._(
      /*i18n*/
      {
        id: "isRobC"
      })
    }))));
  }
  var iconSize = 'lg';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, Object.assign({
    px: "xs"
  }, props.samples), /*#__PURE__*/React.createElement(Trans, {
    id: "d2mxgE"
  }))), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Link, Object.assign({
    px: "xs"
  }, props.plugins), /*#__PURE__*/React.createElement(Trans, {
    id: "ohUJJM"
  }))), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Nav.Dropdown, {
    triggerEvent: "hover"
  }, /*#__PURE__*/React.createElement(Nav.DropdownTrigger, null, /*#__PURE__*/React.createElement(Trans, {
    id: "dtQIWT"
  })), /*#__PURE__*/React.createElement(Nav.DropdownContent, null, /*#__PURE__*/React.createElement(NavBarItem, Object.assign({}, props.messages, {
    icon: /*#__PURE__*/React.createElement(ProductIcon.ProjectsBlue, {
      size: iconSize
    }),
    title: i18n._(
    /*i18n*/
    {
      id: "Zw99NK"
    }),
    subTitle: i18n._(
    /*i18n*/
    {
      id: "nVpcBV"
    })
  })), /*#__PURE__*/React.createElement(NavBarItem, Object.assign({}, props.networkUsers, {
    icon: /*#__PURE__*/React.createElement(ProductIcon.Network, {
      size: iconSize
    }),
    title: i18n._(
    /*i18n*/
    {
      id: "Uy2lzu"
    }),
    subTitle: i18n._(
    /*i18n*/
    {
      id: "T89moB"
    })
  })), /*#__PURE__*/React.createElement(NavBarItem, Object.assign({}, props.networkPro, {
    icon: /*#__PURE__*/React.createElement(ProductIcon.NetworkPro, {
      size: iconSize
    }),
    title: i18n._(
    /*i18n*/
    {
      id: "LBrqUz"
    }),
    subTitle: i18n._(
    /*i18n*/
    {
      id: "hJGRkO"
    })
  })), /*#__PURE__*/React.createElement(NavBarItem, Object.assign({}, props.networkServices, {
    icon: /*#__PURE__*/React.createElement(ProductIcon.NetworkServices, {
      size: iconSize
    }),
    title: i18n._(
    /*i18n*/
    {
      id: "lqRo22"
    }),
    subTitle: i18n._(
    /*i18n*/
    {
      id: "rLupHe"
    })
  })), /*#__PURE__*/React.createElement(NavBarItem, Object.assign({}, props.communityChannels, {
    icon: /*#__PURE__*/React.createElement(ProductIcon.CommunityChannels, {
      size: iconSize
    }),
    title: i18n._(
    /*i18n*/
    {
      id: "MPEFN9"
    }),
    subTitle: i18n._(
    /*i18n*/
    {
      id: "C+zo4L"
    }),
    badgeTitle: i18n._(
    /*i18n*/
    {
      id: "isRobC"
    })
  }))))));
};

export { NavBarItems };
